import * as React from 'react';

import { routes } from 'defs';

import ButtonBar from 'components/molecules/ButtonBar';
import { ButtonBarProps } from 'components/molecules/ButtonBar';
import CoachSelector, { CoachIsEnumType, CoachProps } from 'components/molecules/CoachSelector';
import { AnamnesisStepResolver } from 'components/organisms/Anamnesis';

export type SelectCoachProps = {
	coaches: CoachProps[];
	coach?: CoachIsEnumType;
	actionButtonsActive: ButtonBarProps;
	actionButtonsInactive: ButtonBarProps;
	isUpdatingAnamnesis: boolean;
	onNavigationClick: (targetUrl: { href: string }) => void /* parent */;
	onStepCompleted: (resolver: AnamnesisStepResolver) => void /* parent */;
	doSaveCoach?: Function /* actionCreator */;
};

export type SelectCoachState = {
	selectedCoach?: CoachIsEnumType;
};

export default class SelectCoach extends React.Component<SelectCoachProps, SelectCoachState> {
	public static displayName = 'AnamnesisSelectCoach';
	public static defaultProps = {
		coaches: [],
		actionButtonsActive: {},
		actionButtonsInactive: {},
	};

	constructor(props: SelectCoachProps) {
		super(props);

		this.state = {
			selectedCoach: props.coach,
		};
	}

	public componentDidUpdate(prevProps: SelectCoachProps) {
		if (this.props.coach && prevProps.coach !== this.props.coach) {
			this.setState({
				selectedCoach: this.props.coach,
			});
		}
	}

	public onHandleButtonClicks = (type: string) => {
		const _this = this;
		const currentCoach = this.state.selectedCoach;
		const { onNavigationClick, onStepCompleted } = this.props;

		if (type === 'completed' && typeof onStepCompleted === 'function') {
			return onStepCompleted.apply(null, [
				{
					waitFor: 'savedCoach',
					actionCreator: _this.props.doSaveCoach,
					nextRoute: routes.anamnesis.selectGender,
					data: {
						coach: (currentCoach || '').toUpperCase(),
					},
				},
			]);
		}

		if (typeof onNavigationClick === 'function') {
			type = type === 'completed' ? 'next' : type;
			onNavigationClick.apply(this, [routes.anamnesis.indexRoute]);
		}
	};

	public onChangeCoach = (coach: CoachIsEnumType) => {
		this.setState({
			selectedCoach: coach,
		});
	};

	public render() {
		const { coaches, actionButtonsActive, actionButtonsInactive, isUpdatingAnamnesis } = this.props;

		return (
			<div>
				<CoachSelector
					coaches={coaches}
					selectedCoach={this.state.selectedCoach}
					onCoachChange={this.onChangeCoach}
				/>

				{this.state && this.state.selectedCoach && (
					<div className="o-anamnesis__button-bar">
						<ButtonBar
							{...actionButtonsActive}
							loading={this.props.isUpdatingAnamnesis}
							handleButtonClicks={this.onHandleButtonClicks}
						/>
					</div>
				)}

				{!this.state.selectedCoach && (
					<div className="o-anamnesis__button-bar">
						<ButtonBar
							{...actionButtonsInactive}
							handleButtonClicks={this.onHandleButtonClicks}
							loading={isUpdatingAnamnesis}
						/>
					</div>
				)}
			</div>
		);
	}
}
